export function defineRoutes<T extends Record<string, RouteValue>>(
  routes: T,
): Readonly<T> {
  return routes as Readonly<T>;
}
